import routes from "@/apps/dashboard/buyback/routing/verification/routes";
import * as userConstants from "@/core/models/usersAndPermissions";

export default [
  {
    path: routes.verification.path,
    name: routes.verification.name,
    component: () => import("@/apps/dashboard/buyback/view/pages/Verification/Verification.vue"),
    meta: {
      permission: userConstants.ROLE_BUYBACKITEM_CONTROL_PAGE,
    },
  },
];
